import Page from 'src/apipages/live/events/index';

export default Page;
